var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlay = function SvgIconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    viewBox: "0 0 18 19",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_play_svg__a",
    d: "M9.886 5.469c1.077-1.957 3.143-1.96 4.221 0l6.47 11.75c1.07 1.943.021 3.781-2.158 3.781H5.583c-2.181 0-3.23-1.834-2.16-3.78z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_play_svg__a",
    fillRule: "evenodd",
    transform: "rotate(90 12 9.5)"
  })));
};
export default SvgIconPlay;